// @flow
type ModalToggleActionType = 'MODAL/TOGGLE';

export type ActionType = ModalToggleActionType;

type ModalToggleAction = {
    type: ModalToggleActionType,
    payload: {
        modalName: string,
        isOpen: boolean
    }
};

export const DATE_MODAL = 'DATES';
export const GUEST_MODAL = 'GUESTS';
export const FILTERS_MODAL = 'FILTERS';
export const SEARCH_MODAL = 'SEARCH';
export const FILTERS_DATES_MODAL = 'FILTERS_DATES';
export const FILTERS_GUEST_MODAL = 'FILTERS_GUEST';

export type ModalType =
    | typeof DATE_MODAL
    | typeof FILTERS_MODAL
    | typeof GUEST_MODAL
    | typeof SEARCH_MODAL
    | typeof FILTERS_DATES_MODAL
    | typeof FILTERS_GUEST_MODAL;

export type Action = ModalToggleAction;

export const MODAL_TOGGLE = 'MODAL/TOGGLE';

const ACTION_CREATORS = {
    toggle(modalName: string, isOpen: boolean): ModalToggleAction {
        return {
            type: MODAL_TOGGLE,
            payload: {
                modalName,
                isOpen
            }
        };
    }
};

export default {
    ...ACTION_CREATORS
};
